/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

// utils
import * as accountAPI from 'api/account';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  staffList: [],
  limit: process.env.REACT_APP_TABLE_PER_PAGE || 50,
  offset: 0,
  total: 0
};

const slice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // 获取教职员列表
    getStaffList(state, { payload }) {
      state.isLoading = false;
      const { total, rows } = payload;
      state.staffList = rows;
      state.total = total;
    },
    // 获取教职员列表失敗
    clearStaffList(state) {
      state.isLoading = false;
      state.staffList = [];
      state.total = 0;
    },
    setLimit(state, { payload }) {
      state.limit = payload;
    },
    setOffset(state, { payload }) {
      state.offset = payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { setLimit, setOffset } = slice.actions;

// 获取教职员列表
export function fetchStaffList(params: any) {
  return async (dispatch: any) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await accountAPI.getStaffList(params);
      dispatch(slice.actions.getStaffList(response));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.clearStaffList());
    }
  };
}
